<section class="section-gap bookingHeader">
  <div class="container">
    <section class="sectionHeader">
      <h2>Review Booking</h2>
    </section>
  </div>
</section>
<section class="section-gap bookingMain">
  <div class="container">
    <app-global-breadcrumbs class="d-none"></app-global-breadcrumbs>
    <ng-content></ng-content>
  </div>

</section>
